<!--
 * @Description:  员工转正
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 11:06:21
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <mrc_ess_staffInfo v-model="list.staff_uuid"
                               job_post_name="f4"
                               job_grade_name="f5"
                               client_name="f1"
                               org_level_name="f2"
                               dept_name="f3"
                               itemText="f8"
                               staff_code="f12"
                               itemValue="value_field"
                               :error-messages="$errors('list', 'staff_uuid', requiredRule)"
                               @changeStaffList="changeList"
                               :readonly="disabled"
                               :dropDownList="dropDownList"
                               :disabled="Boolean($store.state.uuid)"
                               :multiple="false"
                               :label="this.$t('label_Regular_employee') + '*'">
            </mrc_ess_staffInfo>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_datePicker :disabled="true"
                                :backgroundColor="disabled ? '' : '#f5f5f5'"
                                :errMsg="
                $errors(
                  'list',
                  'employment_date',
                  requiredRule.concat([
                    {
                      rule: 'beforeDate',
                      msg: $t('verify_The_date_time_period_is_incorrect'),
                    },
                  ])
                )
              "
                                :label="$t('label_The_date_of_entry_to_the_company') + '*'"
                                v-model="list.employment_date"></mrc_ess_datePicker>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_datePicker :disabled="disabled"
                                afterDate
                                :label="$t('label_The_positive_date') + '*'"
                                :errMsg="
                $errors(
                  'list',
                  'probation_end_date',
                  requiredRule.concat([
                    {
                      rule: 'afterDate',
                      msg: $t('verify_The_date_time_period_is_incorrect'),
                    },
                  ])
                )
              "
                                v-model="list.probation_end_date"></mrc_ess_datePicker>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_note')"
                               noRequired
                               :error-messages="
                  $errors('list', 'remarks', nocharacter)
                  "
                               :isNational="judegNational('remarks')"
                               v-model="list.remarks"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         @cancel="cancel"
                         :loading="btnIsLoading"
                         v-if="!disabled"></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getStaffOfficialList,
  addStaffOfficial,
  updateStaffOfficial,
  deleteStaffOfficial,
  detailStaffOfficial,
} from '@/service/api/staffmsg.js'
import { getBusinessList } from '@/service/api/prompt.js'
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      dropDownList: [],
      list: {},
      btnIsLoading: false,
      viewList: {},
    }
  },
  computed: {
    complete_probations () {
      //员工转正参照 
      if (this.$store.state.uuid) {
        return {
          prompt_name: 'complete_probation-update',
          org_level_uuid: this.$store.state.currentCompany,
          staff_uuid: this.list.staff_uuid
        }
      } else {
        return {
          prompt_name: 'complete_probations',
          org_level_uuid: this.$store.state.currentCompany,
        }
      }
    },
  },
  created () { },
  watch: {},
  async mounted () {
    this.national('mrbase_sys_staff_complete_probation')
    if (this.$store.state.uuid) {
      await this.getDetail()
    }
    else {
    }
    getBusinessList(this.complete_probations).then((res) => {
      if (res.code == 200) {
        this.dropDownList = res.data
      }
    })
  },

  methods: {
    paramsChange () { },
    changeList (val) {
      // this.viewList = val
      // this.$set(this.list, 'employment_date', val.entry_datetime)
      this.$set(this.list, 'employment_date', val.f6)
    },
    async getDetail () {
      this.skeletonloading = true
      const res = await detailStaffOfficial({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = res.data
      } else {
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      if (this.$store.state.uuid) {
        updateStaffOfficial(this.$deletefield(null, this.list)).then(
          async (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t('message_The_operation_was_successful'),
              })
              await this.getDetail()
              this.$emit('changeReadonly')
            }
          }
        )
      } else {
        addStaffOfficial(this.list).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            this.$router.push({ name: 'staffOfficial' })
          }
        })
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getDetail()
        this.$emit('changeReadonly')
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        })
          .then((res) => {
            this.$router.push({
              name: 'staffOfficial',
            })
          })
          .catch((err) => { })
      }

    },
  },
  validations: {
    list: {
      staff_uuid: {
        required,
      },
      employment_date: {
        required,
        beforeDate (value) {
          if (!this.list.probation_end_date) return true
          const prevData = new Date(value).valueOf()
          const nextData = new Date(this.list.probation_end_date).valueOf()
          return prevData <= nextData
        },
      },
      probation_end_date: {
        required,
        afterDate (value) {
          if (!this.list.employment_date) return true
          const nextData = new Date(value).valueOf()
          const prevData = new Date(this.list.employment_date).valueOf()
          return prevData <= nextData
        },
      },
      remarks: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      }
    },
  },
}
</script>

<style scoped></style>
